import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle';
import FontAwesome from 'utils/FA';

import { duckify } from "utils/duckify";

import FeeGroupListItemTableRow from './FeeGroupListItemTableRow';
import FeeTypeDetailsModal from './FeeTypeDetailsModal';

const FeeGroupListItemTableRowWrapper = ({ feesData, feeGroupID }) => {
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const tableRows = feesData.map((fee) => {
    return <FeeGroupListItemTableRow feeRulesData={fee.fee_rules} rowData={fee} key={fee.id} />
  });

  return (
    <React.Fragment>
      {tableRows}
      <tr>
        <td colSpan="4">
          <a className="add-item-button fee-entity-add" onClick={() => setShowDetailsModal(true)} href="#">
          <FontAwesome icon={faPlusCircle} /> Add a new fee type to group
          </a>
        </td>
      </tr>
      {showDetailsModal && <FeeTypeDetailsModal feeGroupId={feeGroupID} closeModal={() => setShowDetailsModal(false)} />}
    </React.Fragment>
  )
}

const mapDucksToProps = () => ({});
const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

FeeGroupListItemTableRowWrapper.propTypes = {
  feeGroupID: PropTypes.string,
  feesData: PropTypes.array
};

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(FeeGroupListItemTableRowWrapper);
